window.EcTagConfig = (function () {
  'use strict';

  var COOKIE_NAME = 'ec_tag_config';
  var USER_ATTRIBUTE_COOKIES = [
    'user_plan',
    'customer_type',
    'classic_user_plan',
    'classic_customer_type'
  ];
  var REQUIRED_COOKIES = [COOKIE_NAME].concat(USER_ATTRIBUTE_COOKIES);

  var BADGE_ATTR = 'data-product-tags';
  var TAG_FILTER_ITEM_ATTR = 'data-ec-tag-name';
  var BADGE_SELECTOR = '[' + BADGE_ATTR + ']';
  var BADGE_WRAPPER_SELECTOR = '[data-ec-tag-wrapper]';
  var TAG_FILTER_SELECTOR = '[data-ec-tag-filter]';
  var TAG_FILTER_ITEM_SELECTOR = '[' + TAG_FILTER_ITEM_ATTR + ']';
  var TAG_FILTER_ACTIVE_SELECTOR = '.tag-filters__item.active';
  // Vùng DOM có thể bị re-render sau khi trang đã load; badge bên trong phải được reveal lại.
  var RERENDER_CONTAINER_SELECTORS = [
    '#main-cart-items',
    '#CartDrawer-CartItems',
    // Product detail: đổi variant làm product-variant.js thay innerHTML của vùng này.
    '[id^="product-main-notice-"]'
  ];

  var NOT_FOUND_PATH = '/not-found';
  var NOT_FOUND_LINKS = {
    'shop.koda-kumi-app.com': 'https://shop.koda-kumi-app.com/not-found',
    'mooos-demo-shop': 'https://mooos-demo-shop.myshopify.com/not-found'
  };

  function getCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length < 2) return undefined;
    return parts[1].split(';')[0];
  }

  function hasRequiredCookies() {
    // Native luôn set đủ 5 cookie, giá trị rỗng vẫn hợp lệ - chỉ thiếu cookie mới là state lỗi.
    return REQUIRED_COOKIES.every(function (name) {
      return getCookie(name) !== undefined;
    });
  }

  function isPlainObject(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
  }

  function ruleShapeOf(rule) {
    if (Array.isArray(rule)) return 'list';
    if (isPlainObject(rule)) {
      if (Array.isArray(rule.anyOf)) return 'anyOf';
      if (Array.isArray(rule.allOf)) return 'allOf';
    }
    return null;
  }

  function isValidConfig(candidate) {
    if (!isPlainObject(candidate)) return false;
    if (!Array.isArray(candidate.priority)) return false;
    if (!isPlainObject(candidate.tags)) return false;
    if (!isPlainObject(candidate.labels)) return false;
    if (!isPlainObject(candidate.rules)) return false;

    var ruleKeys = Object.keys(candidate.rules);
    var rulesValid = ruleKeys.every(function (key) {
      var shape = ruleShapeOf(candidate.rules[key]);
      if (!shape) return false;
      if (shape === 'list') return true;
      return candidate.rules[key][shape].every(function (ref) {
        return ruleKeys.indexOf(ref) !== -1;
      });
    });
    if (!rulesValid) return false;

    return candidate.priority.every(function (key) {
      return (
        typeof candidate.tags[key] === 'string' &&
        candidate.tags[key] !== '' &&
        typeof candidate.labels[key] === 'string' &&
        ruleShapeOf(candidate.rules[key]) !== null
      );
    });
  }

  function readConfig() {
    var raw = getCookie(COOKIE_NAME);
    if (!raw) return null;

    var decoded;
    try {
      decoded = decodeURIComponent(raw);
    } catch (error) {
      decoded = raw;
    }

    try {
      var parsed = JSON.parse(decoded);
      return isValidConfig(parsed) ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  var config = readConfig();

  function each(nodeList, callback) {
    Array.prototype.forEach.call(nodeList, callback);
  }

  function eachBadge(root, callback) {
    each((root || document).querySelectorAll(BADGE_SELECTOR), callback);
  }

  function reveal(element) {
    if (element && element.hidden) element.hidden = false;
  }

  function setText(element, text) {
    if (element.textContent !== text) element.textContent = text;
  }

  function payloadTags() {
    return config.priority.map(function (key) {
      return config.tags[key];
    });
  }

  function resolveKey(productTags) {
    if (!config || !Array.isArray(productTags)) return null;
    for (var i = 0; i < config.priority.length; i++) {
      var key = config.priority[i];
      if (productTags.indexOf(config.tags[key]) !== -1) return key;
    }
    return null;
  }

  function badgeKey(badge) {
    try {
      return resolveKey(JSON.parse(badge.getAttribute(BADGE_ATTR)));
    } catch (error) {
      return null;
    }
  }

  function resolveKeyFromBadges(root) {
    if (!config) return null;
    var keys = [];
    eachBadge(root, function (badge) {
      var key = badgeKey(badge);
      if (key) keys.push(key);
    });
    for (var i = 0; i < config.priority.length; i++) {
      if (keys.indexOf(config.priority[i]) !== -1) return config.priority[i];
    }
    return null;
  }

  function userAttributes() {
    return USER_ATTRIBUTE_COOKIES.map(function (name) {
      return getCookie(name);
    }).filter(function (value) {
      return !!value;
    });
  }

  function satisfies(key, attributes, seen) {
    var rule = config.rules[key];
    var shape = ruleShapeOf(rule);
    if (!shape) return true;
    if (seen.indexOf(key) !== -1) return false;

    if (shape === 'list') {
      return attributes.some(function (value) {
        return rule.indexOf(value) !== -1;
      });
    }
    return rule[shape][shape === 'anyOf' ? 'some' : 'every'](function (ref) {
      return satisfies(ref, attributes, seen.concat(key));
    });
  }

  function canBuy(key) {
    if (!config || !key) return true;
    return satisfies(key, userAttributes(), []);
  }

  function renderBadges(root) {
    eachBadge(root, function (badge) {
      var key = badgeKey(badge);
      if (!key) return;
      setText(badge, config.labels[key]);
      reveal(badge);
      reveal(badge.closest ? badge.closest(BADGE_WRAPPER_SELECTOR) : null);
    });
  }

  function renderTagFilters() {
    var bar = document.querySelector(TAG_FILTER_SELECTOR);
    if (!bar) return;

    var allowed = payloadTags();
    var visibleCount = 0;

    each(bar.querySelectorAll(TAG_FILTER_ITEM_SELECTOR), function (item) {
      if (allowed.indexOf(item.getAttribute(TAG_FILTER_ITEM_ATTR)) === -1) return;
      reveal(item);
      visibleCount++;
    });

    if (visibleCount > 0) {
      reveal(bar);
      scrollActiveTagIntoView(bar);
    }
  }

  function scrollActiveTagIntoView(bar) {
    var active = bar.querySelector(TAG_FILTER_ACTIVE_SELECTOR);
    if (!active || active.hidden) return;

    var barRect = bar.getBoundingClientRect();
    var itemRect = active.getBoundingClientRect();
    bar.scrollLeft += itemRect.left - barRect.left - (bar.clientWidth - itemRect.width) / 2;
  }

  function observeRerender() {
    if (typeof MutationObserver !== 'function') return;
    RERENDER_CONTAINER_SELECTORS.forEach(function (selector) {
      each(document.querySelectorAll(selector), function (container) {
        // renderBadges chạy bên trong observer của chính container này nên mọi thao tác ghi phải idempotent.
        new MutationObserver(function () {
          renderBadges(container);
        }).observe(container, { childList: true, subtree: true });
      });
    });
  }

  function notFoundLink() {
    var origin = window.location.origin;
    var hosts = Object.keys(NOT_FOUND_LINKS);
    for (var i = 0; i < hosts.length; i++) {
      if (origin.indexOf(hosts[i]) !== -1) return NOT_FOUND_LINKS[hosts[i]];
    }
    return NOT_FOUND_PATH;
  }

  function redirectToNotFound() {
    if (!window.location || window.location.pathname === NOT_FOUND_PATH) return;
    window.location.href = notFoundLink();
  }

  if (hasRequiredCookies() && config) {
    renderBadges();
    renderTagFilters();
    observeRerender();
  } else {
    redirectToNotFound();
  }

  return {
    resolveKey: resolveKey,
    resolveKeyFromBadges: resolveKeyFromBadges,
    canBuy: canBuy
  };
})();
